module.exports = __webpack_public_path__ + "static/media/founder-sq.2f102e0e.jpg";